<template>
  <v-card elevation="0">
    <v-card-title class="d-flex flex-row card-title">
      <h4 data-testid="yard-spot-multi-selected-title">{{ t('yard.headers.selected') }}</h4>
      <v-spacer></v-spacer>
      <v-btn
        icon="mdi-close"
        variant="text"
        density="comfortable"
        @click="closeDetail"
        data-testid="yard-spot-multi-selected-close-button"></v-btn>
    </v-card-title>
    <v-card-text data-testid="yard-spot-multi-selected-content" class="full-height">
      <div v-for="spot of selectedSpots" :key="spot.id" class="d-flex flex-column mb-4">
        <h3 class="text-uppercase">
          {{ spot.code }}
        </h3>
        <span class="text-capitalize">
          <v-icon size="x-small" color="red" v-if="getSpotStatus(spot) === SpotStatus.ASSIGNED">
            mdi-clock-outline
          </v-icon>
          {{ getTranslatedSpotStatus(spot) }}
        </span>
      </div>
    </v-card-text>
    <v-card-actions class="pa-4">
      <v-btn
        variant="outlined"
        block
        color="error"
        @click="isDeleteConfirmationVisible = true"
        data-testid="yard-spot-multi-selected-delete-button">
        <v-icon size="small" class="mr-2">mdi-delete-outline</v-icon>
        {{ t('yard.buttons.deleteSpots') }}
      </v-btn>
    </v-card-actions>
    <confirm
      :should-show="isDeleteConfirmationVisible"
      delete-confirmation
      show-delete-warning
      persistent
      @result="handleDeleteConfirmationResult"
      :title="t('yard.tooltips.deleteTheseSpots')"
      :message="t('yard.messages.areYouSureYouWantToDeleteSpots', selectedSpots.length)"
      :button-trueA-text="t('global.buttons.yesDelete')"
      button-true-color="error"
      :width="650"></confirm>
  </v-card>
</template>
<script>
import { defineComponent, ref } from 'vue';
import useYard from '@/modules/yard/composables/useYard';
import { SpotStatus } from '@nova/core';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'YardViewSpotAreaMultiSelected',
  emits: ['clear'],
  setup() {
    const { t } = useI18n();
    const yardStore = useYard();
    const selectedSpots = yardStore.selectedSpotsRef;
    const isDeleteConfirmationVisible = ref(false);

    const handleDeleteConfirmationResult = result => {
      if (result) {
        deleteManySpot();
      }
      isDeleteConfirmationVisible.value = false;
    };

    const deleteManySpot = async () => {
      await yardStore.deleteManySpot(selectedSpots.value.map(s => s.id)).then(() => {
        const spotArea = yardStore.spotAreasRef.value.find(
          area => area.id === selectedSpots.value[0].spotAreaId
        );
        yardStore.trackMixpanelEvent(yardStore.MixPanelEvent.DELETE_SPOT, {
          spotArea,
          metadata: {
            number_of_spots: selectedSpots.value.length
          }
        });
      });

      selectedSpots.value = [];
    };

    const closeDetail = () => {
      yardStore.selectedSpotsRef.value = [];
      yardStore.selectedSpotRef.value = null;
    };

    return {
      t,
      closeDetail,
      selectedSpots,
      SpotStatus,
      isDeleteConfirmationVisible,
      handleDeleteConfirmationResult,
      getSpotStatus: yardStore.getSpotStatus,
      getTranslatedSpotStatus: yardStore.getTranslatedSpotStatus,
      deleteManySpot
    };
  }
});
</script>
<style lang="scss" scoped>
.v-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.full-height {
  height: 100%;
  overflow-y: auto;
}
</style>
